import React from "react";
import "./styles/Contact.css";
import BelMailOns from "./compUse/BelMailOns";
import PartnerIntakeForm from "./compUse/PartnerIntakeForm";
import { useState } from "react";

function Contact() {
  // Separate state for contact modal
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactModalContent, setContactModalContent] = useState({
    title: "",
    email: "",
    phone: "",
  });

  // Separate state for partner intake form
  const [showPartnerForm, setShowPartnerForm] = useState(false);

  const handleContactButtonClick = (type) => {
    const content = {
      title: type === "bel" ? "Bel ons" : "Mail ons",
      email: "info@gridarea.nl",
      phone: "+31 6 14 96 45 00",
    };
    setContactModalContent(content);
    setShowContactModal(true);
  };

  const handlePartnerButtonClick = () => {
    setShowPartnerForm(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  const closePartnerForm = () => {
    setShowPartnerForm(false);
  };

  return (
    <div className="contactContainer">
      <div className="contactContent">
        <h2 className="CTAtext">Klaar voor verandering?</h2>
        <p className="CTAtextp">
          Wij helpen je met op maat gemaakte app- en weboplossingen die jouw
          bedrijf laten groeien. <br /> <br /> Neem contact met ons op!
        </p>

        <div className="button-container">
          <button className="belOns" onClick={() => handleContactButtonClick("bel")}>
            Bel ons
          </button>
          <button className="mailOns" onClick={() => handleContactButtonClick("mail")}>
            Mail ons
          </button>
        </div>
        <BelMailOns
          show={showContactModal}
          onClose={closeContactModal}
          title={contactModalContent.title}
          email={contactModalContent.email}
          phone={contactModalContent.phone}
        />
      </div>

      <div className="contactContentPartner">
        <h2 className="CTAtextPartner">Partner in business worden?</h2>
        <p className="CTAtextp">
          Word partner in business! We bieden flexibele samenwerkingen die aansluiten bij jouw wensen.
        </p>

        <div className="button-containerPartner">
         <button className="partnerWorden" onClick={handlePartnerButtonClick}>
            Partner worden
          </button>
        </div>
        <PartnerIntakeForm
          isOpen={showPartnerForm}
          onClose={closePartnerForm}
        />
      </div>
    </div>
  );
}

export default Contact;